"use client";

import { useState } from "react";
import { ArticleCard } from "@/components/article/ArticleCard";
import type { Post } from "@/lib/types";

interface SlidingArticlesProps {
  posts: Post[];
}

export default function SlidingArticles({ posts }: SlidingArticlesProps) {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [isHovered, setIsHovered] = useState(false);

  if (!posts.length) return null;

  // Duplicate posts enough times to ensure smooth scrolling
  const displayedPosts = [...posts, ...posts, ...posts, ...posts];

  return (
    <div className="relative w-full overflow-hidden bg-background py-8">
      <div
        className={`flex gap-6 w-max animate-marquee ${isHovered ? 'paused' : ''}`}
        aria-label="Trending articles carousel"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => {
          setIsHovered(false);
          setHoveredIndex(null);
        }}
      >
        {displayedPosts.map((post, index) => (
          <div
            key={`${post.slug}-${index}`}
            className={`flex-shrink-0 w-[300px] md:w-[350px] transition-all duration-300 ease-out ${hoveredIndex === index
              ? "scale-110 -translate-y-3 z-30 drop-shadow-2xl"
              : hoveredIndex !== null
                ? "scale-95 opacity-60"
                : ""
              }`}
            style={{
              transformOrigin: "center center",
            }}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <ArticleCard post={post} />
          </div>
        ))}
      </div>

      {/* Gradient overlays for fade effect */}
      <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-background to-transparent pointer-events-none z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-background to-transparent pointer-events-none z-10" />
    </div>
  );
}
